var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"p-1",attrs:{"src":"/images/tiktok.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }